import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { i18n } from '../../../i18n/translate.js';
import { FAIcon } from '../../fa-icon/component.js';
var EXPORT_AVAILABILITIES = ['workbook', 'tableau_api'];

var ChartDownloadDropdown = function ChartDownloadDropdown(props) {
  if (!props.canDownloadReport) {
    return null;
  }

  var onSelect = props.onSelect,
      pollingExport = props.pollingExport,
      toolbarButtonVariant = props.toolbarButtonVariant,
      exportAvailability = props.exportAvailability;
  var canExportCSV = EXPORT_AVAILABILITIES.includes(exportAvailability);
  return /*#__PURE__*/React.createElement("div", {
    className: "chart-download-dropdown"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    "data-action": "download-report",
    id: "chart-download-button",
    onSelect: onSelect
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: toolbarButtonVariant,
    className: "chart-toolbar-button chart-download-button"
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "file-arrow-down"
  }), i18n.t('Download Report')), /*#__PURE__*/React.createElement(Dropdown.Menu, null, canExportCSV && /*#__PURE__*/React.createElement(Dropdown.Item, {
    "data-action": "download-csv",
    eventKey: exportAvailability,
    disabled: pollingExport
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "file-csv"
  }), pollingExport ? i18n.t('Generating Report...') : i18n.t('Download CSV')), /*#__PURE__*/React.createElement(Dropdown.Item, {
    eventKey: "image",
    "data-action": "download-image"
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "images"
  }), i18n.t('Download Image')), /*#__PURE__*/React.createElement(Dropdown.Item, {
    eventKey: "pdf",
    "data-action": "download-pdf"
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "file-pdf"
  }), i18n.t('Download PDF')))));
};

ChartDownloadDropdown.displayName = "ChartDownloadDropdown";
export { ChartDownloadDropdown };